module.exports = __webpack_public_path__ + "img/Article-image17.57134fe5.jpg";